"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _input = require("Resources/components/elements/mixins/input");

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["placeholder", "items", "color", "icon", "name", "initialValue", "includeNoneValue"],

  data: function data() {
    return {
      selected: this.initialValue ? this.initialValue : []
    };
  },


  mixins: [_input2.default],

  watch: {
    selected: function selected() {
      this.$emit("change", this.selected);
    }
  },

  computed: {
    classes: function classes() {
      var baseClasses = ["icon-dropdown-wrapper", "clearfix"];

      if (this.color) {
        baseClasses.push("-" + this.color);
      }

      return baseClasses;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/MultiselectField.vue
// module id = rxqu
// module chunks = 0 1